import { render, staticRenderFns } from "./CreateTicketModal.vue?vue&type=template&id=da27ac48&scoped=true"
import script from "./CreateTicketModal.vue?vue&type=script&lang=js"
export * from "./CreateTicketModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTicketModal.vue?vue&type=style&index=0&id=da27ac48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da27ac48",
  null
  
)

export default component.exports